// i18n.js
import { createI18n } from 'vue-i18n'
import he from '../i18n/he'
import ar from '../i18n/ar'
import en from '../i18n/en'

const localeMessages = {
  he,
  ar,
  en,
}

export function isRtlLang(currentLocale) {
  const rtlLanguages = ['he', 'ar']
  return rtlLanguages.includes(currentLocale)
}

export function getCurrentLocale() {
  let lang = window.location.pathname.split('/')[1]
  if (!['he', 'ar', 'en'].includes(lang)) {
    let navigatorLang = window.navigator.language.split('-')[0]
    const availableLocales = Object.keys(localeMessages)
    if (!availableLocales.includes(navigatorLang)) {
      navigatorLang = 'en'
    }
    lang = localStorage.getItem('lang') || navigatorLang
  }
  return lang
}

// Create i18n instance
export const i18n = createI18n({
  availableLocales: Object.keys(localeMessages),
  globalInjection: true,
  locale: getCurrentLocale(),
  fallbackLocale: 'he',
  legacy: false,
  messages: localeMessages,
})

export function setLocale(locale) {
  document.querySelector('html').setAttribute('lang', locale)
  localStorage.setItem('lang', locale)
}

// Export the i18n instance
export default i18n
